unit View.Contas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewContasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbbanco_id: TLabel;
    edbanco_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbtitular: TLabel;
    edtitular: TDBEdit;
    lbabertura: TLabel;
    edabertura: TDBEdit;
    lbagencia_nome: TLabel;
    edagencia_nome: TDBEdit;
    lbagencia_numero: TLabel;
    edagencia_numero: TDBEdit;
    lbagencia_dv: TLabel;
    edagencia_dv: TDBEdit;
    lbconta_numero: TLabel;
    edconta_numero: TDBEdit;
    lbconta_dv: TLabel;
    edconta_dv: TDBEdit;
    lbdv_agencia_conta: TLabel;
    eddv_agencia_conta: TDBEdit;
    lbcodigo_mestre: TLabel;
    edcodigo_mestre: TDBEdit;
    lbsaldo_abertura: TLabel;
    edsaldo_abertura: TDBEdit;
    lbsaldo: TLabel;
    edsaldo: TDBEdit;
    lbobs: TLabel;
    edobs: TDBEdit;
    lbcpf_cnpj: TLabel;
    edcpf_cnpj: TDBEdit;
    lbconta_bancaria: TLabel;
    edconta_bancaria: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientContasGet: TXDataWebClient;
    XDataClientContasDelete: TXDataWebClient;
    ContasDataset: TXDataWebDataSet;
    ContasDatasetid: TIntegerField;
    ContasDatasetaliado_id: TIntegerField;
    ContasDatasetdata_base_id: TIntegerField;
    ContasDatasetbanco_id: TIntegerField;
    ContasDatasetnome: TStringField;
    ContasDatasettitular: TStringField;
    ContasDatasetabertura: TDateTimeField;
    ContasDatasetagencia_nome: TStringField;
    ContasDatasetagencia_numero: TStringField;
    ContasDatasetagencia_dv: TStringField;
    ContasDatasetconta_numero: TStringField;
    ContasDatasetconta_dv: TStringField;
    ContasDatasetdv_agencia_conta: TStringField;
    ContasDatasetcodigo_mestre: TStringField;
    ContasDatasetsaldo_abertura: TFloatField;
    ContasDatasetsaldo: TFloatField;
    ContasDatasetobs: TStringField;
    ContasDatasetcpf_cnpj: TStringField;
    ContasDatasetconta_bancaria: TBooleanField;
    ContasDatasetcodigo_interno: TIntegerField;
    ContasDatasetexcluido: TBooleanField;
    ContasDatasetinclusao: TDateTimeField;
    ContasDatasetalteracao: TDateTimeField;
    ContasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientContasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientContasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientContasDeleteError(Error: TXDataClientError);
    procedure ContasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewContasEdit: TFViewContasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewContasEdit }

procedure TFViewContasEdit.btSaveClick(Sender: TObject);
begin
  if ContasDataset.State in dsEditModes then
  begin
        ContasDataset.Post;
    ContasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewContasEdit.btDeleteClick(Sender: TObject);
begin
  if ContasDataset.State in dsEditModes then
    ContasDataset.Post;
  XDataClientContasDelete.Delete(ContasDataset.EntitySetName,
    TJSObject(ContasDataset.CurrentData));
end;


class function TFViewContasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewContasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewContasEdit.InsertEntity;
begin
  ContasDataset.Close;
  ContasDataset.SetJsonData('{}');
  ContasDataset.Open;
  ContasDataset.Insert;
end;

class function TFViewContasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewContasEdit(AForm).FInserting := AInserting;
    TFViewContasEdit(AForm).FId := AId;
    TFViewContasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewContasEdit(AForm).InsertEntity
    else
      TFViewContasEdit(AForm).LoadEntity;
    TFViewContasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewContasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewContasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ContasDataset.Connection.Model.DefaultSchema.FindEntityType(
      ContasDataset.EntitySetName
    )
  );
  XDataClientContasGet.Get(ContasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewContasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewContasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewContasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewContasEdit.XDataClientContasGetLoad(Response: TXDataClientResponse);
begin
  ContasDataset.Close;
  ContasDataset.SetJsonData(Response.Result);
  ContasDataset.Open;
  
  ContasDataset.Edit;  
end;

procedure TFViewContasEdit.XDataClientContasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewContasEdit.XDataClientContasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewContasEdit.ContasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewContasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewContasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.contas.form.message');
  lbMessage := TLabel.Create('view.contas.form.message.label');
  btCloseMessage := TButton.Create('view.contas.form.message.button');
  btCancel := TButton.Create('view.contas.form.btBack');
  btSave := TButton.Create('view.contas.form.btSave');
  btDelete := TButton.Create('view.contas.form.btDelete');
  lbid := TLabel.Create('view.contas.form.lbid');
  edid := TDBEdit.Create('view.contas.form.edid');
  lbaliado_id := TLabel.Create('view.contas.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.contas.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.contas.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.contas.form.eddata_base_id');
  lbbanco_id := TLabel.Create('view.contas.form.lbbanco_id');
  edbanco_id := TDBEdit.Create('view.contas.form.edbanco_id');
  lbnome := TLabel.Create('view.contas.form.lbnome');
  ednome := TDBEdit.Create('view.contas.form.ednome');
  lbtitular := TLabel.Create('view.contas.form.lbtitular');
  edtitular := TDBEdit.Create('view.contas.form.edtitular');
  lbabertura := TLabel.Create('view.contas.form.lbabertura');
  edabertura := TDBEdit.Create('view.contas.form.edabertura');
  lbagencia_nome := TLabel.Create('view.contas.form.lbagencia_nome');
  edagencia_nome := TDBEdit.Create('view.contas.form.edagencia_nome');
  lbagencia_numero := TLabel.Create('view.contas.form.lbagencia_numero');
  edagencia_numero := TDBEdit.Create('view.contas.form.edagencia_numero');
  lbagencia_dv := TLabel.Create('view.contas.form.lbagencia_dv');
  edagencia_dv := TDBEdit.Create('view.contas.form.edagencia_dv');
  lbconta_numero := TLabel.Create('view.contas.form.lbconta_numero');
  edconta_numero := TDBEdit.Create('view.contas.form.edconta_numero');
  lbconta_dv := TLabel.Create('view.contas.form.lbconta_dv');
  edconta_dv := TDBEdit.Create('view.contas.form.edconta_dv');
  lbdv_agencia_conta := TLabel.Create('view.contas.form.lbdv_agencia_conta');
  eddv_agencia_conta := TDBEdit.Create('view.contas.form.eddv_agencia_conta');
  lbcodigo_mestre := TLabel.Create('view.contas.form.lbcodigo_mestre');
  edcodigo_mestre := TDBEdit.Create('view.contas.form.edcodigo_mestre');
  lbsaldo_abertura := TLabel.Create('view.contas.form.lbsaldo_abertura');
  edsaldo_abertura := TDBEdit.Create('view.contas.form.edsaldo_abertura');
  lbsaldo := TLabel.Create('view.contas.form.lbsaldo');
  edsaldo := TDBEdit.Create('view.contas.form.edsaldo');
  lbobs := TLabel.Create('view.contas.form.lbobs');
  edobs := TDBEdit.Create('view.contas.form.edobs');
  lbcpf_cnpj := TLabel.Create('view.contas.form.lbcpf_cnpj');
  edcpf_cnpj := TDBEdit.Create('view.contas.form.edcpf_cnpj');
  lbconta_bancaria := TLabel.Create('view.contas.form.lbconta_bancaria');
  edconta_bancaria := TDBEdit.Create('view.contas.form.edconta_bancaria');
  lbcodigo_interno := TLabel.Create('view.contas.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.contas.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.contas.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.contas.form.edexcluido');
  lbinclusao := TLabel.Create('view.contas.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.contas.form.edinclusao');
  lbalteracao := TLabel.Create('view.contas.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.contas.form.edalteracao');
  lbexclusao := TLabel.Create('view.contas.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.contas.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  ContasDataset := TXDataWebDataSet.Create(Self);
  ContasDatasetid := TIntegerField.Create(Self);
  ContasDatasetaliado_id := TIntegerField.Create(Self);
  ContasDatasetdata_base_id := TIntegerField.Create(Self);
  ContasDatasetbanco_id := TIntegerField.Create(Self);
  ContasDatasetnome := TStringField.Create(Self);
  ContasDatasettitular := TStringField.Create(Self);
  ContasDatasetabertura := TDateTimeField.Create(Self);
  ContasDatasetagencia_nome := TStringField.Create(Self);
  ContasDatasetagencia_numero := TStringField.Create(Self);
  ContasDatasetagencia_dv := TStringField.Create(Self);
  ContasDatasetconta_numero := TStringField.Create(Self);
  ContasDatasetconta_dv := TStringField.Create(Self);
  ContasDatasetdv_agencia_conta := TStringField.Create(Self);
  ContasDatasetcodigo_mestre := TStringField.Create(Self);
  ContasDatasetsaldo_abertura := TFloatField.Create(Self);
  ContasDatasetsaldo := TFloatField.Create(Self);
  ContasDatasetobs := TStringField.Create(Self);
  ContasDatasetcpf_cnpj := TStringField.Create(Self);
  ContasDatasetconta_bancaria := TBooleanField.Create(Self);
  ContasDatasetcodigo_interno := TIntegerField.Create(Self);
  ContasDatasetexcluido := TBooleanField.Create(Self);
  ContasDatasetinclusao := TDateTimeField.Create(Self);
  ContasDatasetalteracao := TDateTimeField.Create(Self);
  ContasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientContasGet := TXDataWebClient.Create(Self);
  XDataClientContasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbbanco_id.BeforeLoadDFMValues;
  edbanco_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbtitular.BeforeLoadDFMValues;
  edtitular.BeforeLoadDFMValues;
  lbabertura.BeforeLoadDFMValues;
  edabertura.BeforeLoadDFMValues;
  lbagencia_nome.BeforeLoadDFMValues;
  edagencia_nome.BeforeLoadDFMValues;
  lbagencia_numero.BeforeLoadDFMValues;
  edagencia_numero.BeforeLoadDFMValues;
  lbagencia_dv.BeforeLoadDFMValues;
  edagencia_dv.BeforeLoadDFMValues;
  lbconta_numero.BeforeLoadDFMValues;
  edconta_numero.BeforeLoadDFMValues;
  lbconta_dv.BeforeLoadDFMValues;
  edconta_dv.BeforeLoadDFMValues;
  lbdv_agencia_conta.BeforeLoadDFMValues;
  eddv_agencia_conta.BeforeLoadDFMValues;
  lbcodigo_mestre.BeforeLoadDFMValues;
  edcodigo_mestre.BeforeLoadDFMValues;
  lbsaldo_abertura.BeforeLoadDFMValues;
  edsaldo_abertura.BeforeLoadDFMValues;
  lbsaldo.BeforeLoadDFMValues;
  edsaldo.BeforeLoadDFMValues;
  lbobs.BeforeLoadDFMValues;
  edobs.BeforeLoadDFMValues;
  lbcpf_cnpj.BeforeLoadDFMValues;
  edcpf_cnpj.BeforeLoadDFMValues;
  lbconta_bancaria.BeforeLoadDFMValues;
  edconta_bancaria.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ContasDataset.BeforeLoadDFMValues;
  ContasDatasetid.BeforeLoadDFMValues;
  ContasDatasetaliado_id.BeforeLoadDFMValues;
  ContasDatasetdata_base_id.BeforeLoadDFMValues;
  ContasDatasetbanco_id.BeforeLoadDFMValues;
  ContasDatasetnome.BeforeLoadDFMValues;
  ContasDatasettitular.BeforeLoadDFMValues;
  ContasDatasetabertura.BeforeLoadDFMValues;
  ContasDatasetagencia_nome.BeforeLoadDFMValues;
  ContasDatasetagencia_numero.BeforeLoadDFMValues;
  ContasDatasetagencia_dv.BeforeLoadDFMValues;
  ContasDatasetconta_numero.BeforeLoadDFMValues;
  ContasDatasetconta_dv.BeforeLoadDFMValues;
  ContasDatasetdv_agencia_conta.BeforeLoadDFMValues;
  ContasDatasetcodigo_mestre.BeforeLoadDFMValues;
  ContasDatasetsaldo_abertura.BeforeLoadDFMValues;
  ContasDatasetsaldo.BeforeLoadDFMValues;
  ContasDatasetobs.BeforeLoadDFMValues;
  ContasDatasetcpf_cnpj.BeforeLoadDFMValues;
  ContasDatasetconta_bancaria.BeforeLoadDFMValues;
  ContasDatasetcodigo_interno.BeforeLoadDFMValues;
  ContasDatasetexcluido.BeforeLoadDFMValues;
  ContasDatasetinclusao.BeforeLoadDFMValues;
  ContasDatasetalteracao.BeforeLoadDFMValues;
  ContasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientContasGet.BeforeLoadDFMValues;
  XDataClientContasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewContasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 913;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 853;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 853;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 853;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbbanco_id.SetParentComponent(Self);
    lbbanco_id.Name := 'lbbanco_id';
    lbbanco_id.Left := 24;
    lbbanco_id.Top := 273;
    lbbanco_id.Width := 14;
    lbbanco_id.Height := 13;
    lbbanco_id.Caption := 'banco_id:';
    lbbanco_id.Transparent := True;
    edbanco_id.SetParentComponent(Self);
    edbanco_id.Name := 'edbanco_id';
    edbanco_id.Left := 221;
    edbanco_id.Top := 270;
    edbanco_id.Width := 200;
    edbanco_id.Height := 21;
    edbanco_id.Enabled := True;
    edbanco_id.TabOrder := 9;
    edbanco_id.Text := 'edbanco_id';
    edbanco_id.DataField := 'banco_id';
    edbanco_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 300;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 297;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 10;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbtitular.SetParentComponent(Self);
    lbtitular.Name := 'lbtitular';
    lbtitular.Left := 24;
    lbtitular.Top := 327;
    lbtitular.Width := 14;
    lbtitular.Height := 13;
    lbtitular.Caption := 'titular:';
    lbtitular.Transparent := True;
    edtitular.SetParentComponent(Self);
    edtitular.Name := 'edtitular';
    edtitular.Left := 221;
    edtitular.Top := 324;
    edtitular.Width := 200;
    edtitular.Height := 21;
    edtitular.Enabled := True;
    edtitular.TabOrder := 11;
    edtitular.Text := 'edtitular';
    edtitular.DataField := 'titular';
    edtitular.DataSource := DataSource;
    lbabertura.SetParentComponent(Self);
    lbabertura.Name := 'lbabertura';
    lbabertura.Left := 24;
    lbabertura.Top := 354;
    lbabertura.Width := 14;
    lbabertura.Height := 13;
    lbabertura.Caption := 'abertura:';
    lbabertura.Transparent := True;
    edabertura.SetParentComponent(Self);
    edabertura.Name := 'edabertura';
    edabertura.Left := 221;
    edabertura.Top := 351;
    edabertura.Width := 200;
    edabertura.Height := 21;
    edabertura.Enabled := True;
    edabertura.TabOrder := 12;
    edabertura.Text := 'edabertura';
    edabertura.DataField := 'abertura';
    edabertura.DataSource := DataSource;
    lbagencia_nome.SetParentComponent(Self);
    lbagencia_nome.Name := 'lbagencia_nome';
    lbagencia_nome.Left := 24;
    lbagencia_nome.Top := 381;
    lbagencia_nome.Width := 14;
    lbagencia_nome.Height := 13;
    lbagencia_nome.Caption := 'agencia_nome:';
    lbagencia_nome.Transparent := True;
    edagencia_nome.SetParentComponent(Self);
    edagencia_nome.Name := 'edagencia_nome';
    edagencia_nome.Left := 221;
    edagencia_nome.Top := 378;
    edagencia_nome.Width := 200;
    edagencia_nome.Height := 21;
    edagencia_nome.Enabled := True;
    edagencia_nome.TabOrder := 13;
    edagencia_nome.Text := 'edagencia_nome';
    edagencia_nome.DataField := 'agencia_nome';
    edagencia_nome.DataSource := DataSource;
    lbagencia_numero.SetParentComponent(Self);
    lbagencia_numero.Name := 'lbagencia_numero';
    lbagencia_numero.Left := 24;
    lbagencia_numero.Top := 408;
    lbagencia_numero.Width := 14;
    lbagencia_numero.Height := 13;
    lbagencia_numero.Caption := 'agencia_numero:';
    lbagencia_numero.Transparent := True;
    edagencia_numero.SetParentComponent(Self);
    edagencia_numero.Name := 'edagencia_numero';
    edagencia_numero.Left := 221;
    edagencia_numero.Top := 405;
    edagencia_numero.Width := 200;
    edagencia_numero.Height := 21;
    edagencia_numero.Enabled := True;
    edagencia_numero.TabOrder := 14;
    edagencia_numero.Text := 'edagencia_numero';
    edagencia_numero.DataField := 'agencia_numero';
    edagencia_numero.DataSource := DataSource;
    lbagencia_dv.SetParentComponent(Self);
    lbagencia_dv.Name := 'lbagencia_dv';
    lbagencia_dv.Left := 24;
    lbagencia_dv.Top := 435;
    lbagencia_dv.Width := 14;
    lbagencia_dv.Height := 13;
    lbagencia_dv.Caption := 'agencia_dv:';
    lbagencia_dv.Transparent := True;
    edagencia_dv.SetParentComponent(Self);
    edagencia_dv.Name := 'edagencia_dv';
    edagencia_dv.Left := 221;
    edagencia_dv.Top := 432;
    edagencia_dv.Width := 200;
    edagencia_dv.Height := 21;
    edagencia_dv.Enabled := True;
    edagencia_dv.TabOrder := 15;
    edagencia_dv.Text := 'edagencia_dv';
    edagencia_dv.DataField := 'agencia_dv';
    edagencia_dv.DataSource := DataSource;
    lbconta_numero.SetParentComponent(Self);
    lbconta_numero.Name := 'lbconta_numero';
    lbconta_numero.Left := 24;
    lbconta_numero.Top := 462;
    lbconta_numero.Width := 14;
    lbconta_numero.Height := 13;
    lbconta_numero.Caption := 'conta_numero:';
    lbconta_numero.Transparent := True;
    edconta_numero.SetParentComponent(Self);
    edconta_numero.Name := 'edconta_numero';
    edconta_numero.Left := 221;
    edconta_numero.Top := 459;
    edconta_numero.Width := 200;
    edconta_numero.Height := 21;
    edconta_numero.Enabled := True;
    edconta_numero.TabOrder := 16;
    edconta_numero.Text := 'edconta_numero';
    edconta_numero.DataField := 'conta_numero';
    edconta_numero.DataSource := DataSource;
    lbconta_dv.SetParentComponent(Self);
    lbconta_dv.Name := 'lbconta_dv';
    lbconta_dv.Left := 24;
    lbconta_dv.Top := 489;
    lbconta_dv.Width := 14;
    lbconta_dv.Height := 13;
    lbconta_dv.Caption := 'conta_dv:';
    lbconta_dv.Transparent := True;
    edconta_dv.SetParentComponent(Self);
    edconta_dv.Name := 'edconta_dv';
    edconta_dv.Left := 221;
    edconta_dv.Top := 486;
    edconta_dv.Width := 200;
    edconta_dv.Height := 21;
    edconta_dv.Enabled := True;
    edconta_dv.TabOrder := 17;
    edconta_dv.Text := 'edconta_dv';
    edconta_dv.DataField := 'conta_dv';
    edconta_dv.DataSource := DataSource;
    lbdv_agencia_conta.SetParentComponent(Self);
    lbdv_agencia_conta.Name := 'lbdv_agencia_conta';
    lbdv_agencia_conta.Left := 24;
    lbdv_agencia_conta.Top := 516;
    lbdv_agencia_conta.Width := 14;
    lbdv_agencia_conta.Height := 13;
    lbdv_agencia_conta.Caption := 'dv_agencia_conta:';
    lbdv_agencia_conta.Transparent := True;
    eddv_agencia_conta.SetParentComponent(Self);
    eddv_agencia_conta.Name := 'eddv_agencia_conta';
    eddv_agencia_conta.Left := 221;
    eddv_agencia_conta.Top := 513;
    eddv_agencia_conta.Width := 200;
    eddv_agencia_conta.Height := 21;
    eddv_agencia_conta.Enabled := True;
    eddv_agencia_conta.TabOrder := 18;
    eddv_agencia_conta.Text := 'eddv_agencia_conta';
    eddv_agencia_conta.DataField := 'dv_agencia_conta';
    eddv_agencia_conta.DataSource := DataSource;
    lbcodigo_mestre.SetParentComponent(Self);
    lbcodigo_mestre.Name := 'lbcodigo_mestre';
    lbcodigo_mestre.Left := 24;
    lbcodigo_mestre.Top := 543;
    lbcodigo_mestre.Width := 14;
    lbcodigo_mestre.Height := 13;
    lbcodigo_mestre.Caption := 'codigo_mestre:';
    lbcodigo_mestre.Transparent := True;
    edcodigo_mestre.SetParentComponent(Self);
    edcodigo_mestre.Name := 'edcodigo_mestre';
    edcodigo_mestre.Left := 221;
    edcodigo_mestre.Top := 540;
    edcodigo_mestre.Width := 200;
    edcodigo_mestre.Height := 21;
    edcodigo_mestre.Enabled := True;
    edcodigo_mestre.TabOrder := 19;
    edcodigo_mestre.Text := 'edcodigo_mestre';
    edcodigo_mestre.DataField := 'codigo_mestre';
    edcodigo_mestre.DataSource := DataSource;
    lbsaldo_abertura.SetParentComponent(Self);
    lbsaldo_abertura.Name := 'lbsaldo_abertura';
    lbsaldo_abertura.Left := 24;
    lbsaldo_abertura.Top := 570;
    lbsaldo_abertura.Width := 14;
    lbsaldo_abertura.Height := 13;
    lbsaldo_abertura.Caption := 'saldo_abertura:';
    lbsaldo_abertura.Transparent := True;
    edsaldo_abertura.SetParentComponent(Self);
    edsaldo_abertura.Name := 'edsaldo_abertura';
    edsaldo_abertura.Left := 221;
    edsaldo_abertura.Top := 567;
    edsaldo_abertura.Width := 200;
    edsaldo_abertura.Height := 21;
    edsaldo_abertura.Enabled := True;
    edsaldo_abertura.TabOrder := 20;
    edsaldo_abertura.Text := 'edsaldo_abertura';
    edsaldo_abertura.DataField := 'saldo_abertura';
    edsaldo_abertura.DataSource := DataSource;
    lbsaldo.SetParentComponent(Self);
    lbsaldo.Name := 'lbsaldo';
    lbsaldo.Left := 24;
    lbsaldo.Top := 597;
    lbsaldo.Width := 14;
    lbsaldo.Height := 13;
    lbsaldo.Caption := 'saldo:';
    lbsaldo.Transparent := True;
    edsaldo.SetParentComponent(Self);
    edsaldo.Name := 'edsaldo';
    edsaldo.Left := 221;
    edsaldo.Top := 594;
    edsaldo.Width := 200;
    edsaldo.Height := 21;
    edsaldo.Enabled := True;
    edsaldo.TabOrder := 21;
    edsaldo.Text := 'edsaldo';
    edsaldo.DataField := 'saldo';
    edsaldo.DataSource := DataSource;
    lbobs.SetParentComponent(Self);
    lbobs.Name := 'lbobs';
    lbobs.Left := 24;
    lbobs.Top := 624;
    lbobs.Width := 14;
    lbobs.Height := 13;
    lbobs.Caption := 'obs:';
    lbobs.Transparent := True;
    edobs.SetParentComponent(Self);
    edobs.Name := 'edobs';
    edobs.Left := 221;
    edobs.Top := 621;
    edobs.Width := 200;
    edobs.Height := 21;
    edobs.Enabled := True;
    edobs.TabOrder := 22;
    edobs.Text := 'edobs';
    edobs.DataField := 'obs';
    edobs.DataSource := DataSource;
    lbcpf_cnpj.SetParentComponent(Self);
    lbcpf_cnpj.Name := 'lbcpf_cnpj';
    lbcpf_cnpj.Left := 24;
    lbcpf_cnpj.Top := 651;
    lbcpf_cnpj.Width := 14;
    lbcpf_cnpj.Height := 13;
    lbcpf_cnpj.Caption := 'cpf_cnpj:';
    lbcpf_cnpj.Transparent := True;
    edcpf_cnpj.SetParentComponent(Self);
    edcpf_cnpj.Name := 'edcpf_cnpj';
    edcpf_cnpj.Left := 221;
    edcpf_cnpj.Top := 648;
    edcpf_cnpj.Width := 200;
    edcpf_cnpj.Height := 21;
    edcpf_cnpj.Enabled := True;
    edcpf_cnpj.TabOrder := 23;
    edcpf_cnpj.Text := 'edcpf_cnpj';
    edcpf_cnpj.DataField := 'cpf_cnpj';
    edcpf_cnpj.DataSource := DataSource;
    lbconta_bancaria.SetParentComponent(Self);
    lbconta_bancaria.Name := 'lbconta_bancaria';
    lbconta_bancaria.Left := 24;
    lbconta_bancaria.Top := 678;
    lbconta_bancaria.Width := 14;
    lbconta_bancaria.Height := 13;
    lbconta_bancaria.Caption := 'conta_bancaria:';
    lbconta_bancaria.Transparent := True;
    edconta_bancaria.SetParentComponent(Self);
    edconta_bancaria.Name := 'edconta_bancaria';
    edconta_bancaria.Left := 221;
    edconta_bancaria.Top := 675;
    edconta_bancaria.Width := 200;
    edconta_bancaria.Height := 21;
    edconta_bancaria.Enabled := True;
    edconta_bancaria.TabOrder := 24;
    edconta_bancaria.Text := 'edconta_bancaria';
    edconta_bancaria.DataField := 'conta_bancaria';
    edconta_bancaria.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 705;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 702;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 25;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 732;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 729;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 26;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 759;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 756;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 27;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 786;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 783;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 28;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 813;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 810;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 29;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ContasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    ContasDataset.SetParentComponent(Self);
    ContasDataset.Name := 'ContasDataset';
    ContasDataset.AfterApplyUpdates := ContasDatasetAfterApplyUpdates;
    ContasDataset.EntitySetName := 'Contas';
    ContasDataset.Connection := DMConnection.ApiConnection;
    ContasDataset.Left := 176;
    ContasDataset.Top := 8;
    ContasDatasetid.SetParentComponent(ContasDataset);
    ContasDatasetid.Name := 'ContasDatasetid';
    ContasDatasetid.FieldName := 'id';
    ContasDatasetid.Required := True;
    ContasDatasetaliado_id.SetParentComponent(ContasDataset);
    ContasDatasetaliado_id.Name := 'ContasDatasetaliado_id';
    ContasDatasetaliado_id.FieldName := 'aliado_id';
    ContasDatasetaliado_id.Required := True;
    ContasDatasetdata_base_id.SetParentComponent(ContasDataset);
    ContasDatasetdata_base_id.Name := 'ContasDatasetdata_base_id';
    ContasDatasetdata_base_id.FieldName := 'data_base_id';
    ContasDatasetdata_base_id.Required := True;
    ContasDatasetbanco_id.SetParentComponent(ContasDataset);
    ContasDatasetbanco_id.Name := 'ContasDatasetbanco_id';
    ContasDatasetbanco_id.FieldName := 'banco_id';
    ContasDatasetbanco_id.Required := False;
    ContasDatasetnome.SetParentComponent(ContasDataset);
    ContasDatasetnome.Name := 'ContasDatasetnome';
    ContasDatasetnome.FieldName := 'nome';
    ContasDatasetnome.Required := True;
    ContasDatasetnome.Size := 255;
    ContasDatasettitular.SetParentComponent(ContasDataset);
    ContasDatasettitular.Name := 'ContasDatasettitular';
    ContasDatasettitular.FieldName := 'titular';
    ContasDatasettitular.Required := False;
    ContasDatasettitular.Size := 255;
    ContasDatasetabertura.SetParentComponent(ContasDataset);
    ContasDatasetabertura.Name := 'ContasDatasetabertura';
    ContasDatasetabertura.FieldName := 'abertura';
    ContasDatasetabertura.Required := True;
    ContasDatasetagencia_nome.SetParentComponent(ContasDataset);
    ContasDatasetagencia_nome.Name := 'ContasDatasetagencia_nome';
    ContasDatasetagencia_nome.FieldName := 'agencia_nome';
    ContasDatasetagencia_nome.Required := False;
    ContasDatasetagencia_nome.Size := 255;
    ContasDatasetagencia_numero.SetParentComponent(ContasDataset);
    ContasDatasetagencia_numero.Name := 'ContasDatasetagencia_numero';
    ContasDatasetagencia_numero.FieldName := 'agencia_numero';
    ContasDatasetagencia_numero.Required := False;
    ContasDatasetagencia_numero.Size := 255;
    ContasDatasetagencia_dv.SetParentComponent(ContasDataset);
    ContasDatasetagencia_dv.Name := 'ContasDatasetagencia_dv';
    ContasDatasetagencia_dv.FieldName := 'agencia_dv';
    ContasDatasetagencia_dv.Required := False;
    ContasDatasetagencia_dv.Size := 255;
    ContasDatasetconta_numero.SetParentComponent(ContasDataset);
    ContasDatasetconta_numero.Name := 'ContasDatasetconta_numero';
    ContasDatasetconta_numero.FieldName := 'conta_numero';
    ContasDatasetconta_numero.Required := False;
    ContasDatasetconta_numero.Size := 255;
    ContasDatasetconta_dv.SetParentComponent(ContasDataset);
    ContasDatasetconta_dv.Name := 'ContasDatasetconta_dv';
    ContasDatasetconta_dv.FieldName := 'conta_dv';
    ContasDatasetconta_dv.Required := False;
    ContasDatasetconta_dv.Size := 255;
    ContasDatasetdv_agencia_conta.SetParentComponent(ContasDataset);
    ContasDatasetdv_agencia_conta.Name := 'ContasDatasetdv_agencia_conta';
    ContasDatasetdv_agencia_conta.FieldName := 'dv_agencia_conta';
    ContasDatasetdv_agencia_conta.Required := False;
    ContasDatasetdv_agencia_conta.Size := 255;
    ContasDatasetcodigo_mestre.SetParentComponent(ContasDataset);
    ContasDatasetcodigo_mestre.Name := 'ContasDatasetcodigo_mestre';
    ContasDatasetcodigo_mestre.FieldName := 'codigo_mestre';
    ContasDatasetcodigo_mestre.Required := False;
    ContasDatasetcodigo_mestre.Size := 255;
    ContasDatasetsaldo_abertura.SetParentComponent(ContasDataset);
    ContasDatasetsaldo_abertura.Name := 'ContasDatasetsaldo_abertura';
    ContasDatasetsaldo_abertura.FieldName := 'saldo_abertura';
    ContasDatasetsaldo_abertura.Required := False;
    ContasDatasetsaldo.SetParentComponent(ContasDataset);
    ContasDatasetsaldo.Name := 'ContasDatasetsaldo';
    ContasDatasetsaldo.FieldName := 'saldo';
    ContasDatasetsaldo.Required := True;
    ContasDatasetobs.SetParentComponent(ContasDataset);
    ContasDatasetobs.Name := 'ContasDatasetobs';
    ContasDatasetobs.FieldName := 'obs';
    ContasDatasetobs.Required := False;
    ContasDatasetobs.Size := 255;
    ContasDatasetcpf_cnpj.SetParentComponent(ContasDataset);
    ContasDatasetcpf_cnpj.Name := 'ContasDatasetcpf_cnpj';
    ContasDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    ContasDatasetcpf_cnpj.Required := False;
    ContasDatasetcpf_cnpj.Size := 255;
    ContasDatasetconta_bancaria.SetParentComponent(ContasDataset);
    ContasDatasetconta_bancaria.Name := 'ContasDatasetconta_bancaria';
    ContasDatasetconta_bancaria.FieldName := 'conta_bancaria';
    ContasDatasetconta_bancaria.Required := True;
    ContasDatasetcodigo_interno.SetParentComponent(ContasDataset);
    ContasDatasetcodigo_interno.Name := 'ContasDatasetcodigo_interno';
    ContasDatasetcodigo_interno.FieldName := 'codigo_interno';
    ContasDatasetcodigo_interno.Required := True;
    ContasDatasetexcluido.SetParentComponent(ContasDataset);
    ContasDatasetexcluido.Name := 'ContasDatasetexcluido';
    ContasDatasetexcluido.FieldName := 'excluido';
    ContasDatasetexcluido.Required := False;
    ContasDatasetinclusao.SetParentComponent(ContasDataset);
    ContasDatasetinclusao.Name := 'ContasDatasetinclusao';
    ContasDatasetinclusao.FieldName := 'inclusao';
    ContasDatasetinclusao.Required := False;
    ContasDatasetalteracao.SetParentComponent(ContasDataset);
    ContasDatasetalteracao.Name := 'ContasDatasetalteracao';
    ContasDatasetalteracao.FieldName := 'alteracao';
    ContasDatasetalteracao.Required := False;
    ContasDatasetexclusao.SetParentComponent(ContasDataset);
    ContasDatasetexclusao.Name := 'ContasDatasetexclusao';
    ContasDatasetexclusao.FieldName := 'exclusao';
    ContasDatasetexclusao.Required := False;
    XDataClientContasGet.SetParentComponent(Self);
    XDataClientContasGet.Name := 'XDataClientContasGet';
    XDataClientContasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientContasGet, Self, 'OnLoad', 'XDataClientContasGetLoad');
    XDataClientContasGet.Left := 64;
    XDataClientContasGet.Top := 8;
    XDataClientContasDelete.SetParentComponent(Self);
    XDataClientContasDelete.Name := 'XDataClientContasDelete';
    XDataClientContasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientContasDelete, Self, 'OnLoad', 'XDataClientContasDeleteLoad');
    SetEvent(XDataClientContasDelete, Self, 'OnError', 'XDataClientContasDeleteError');
    XDataClientContasDelete.Left := 64;
    XDataClientContasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbbanco_id.AfterLoadDFMValues;
    edbanco_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbtitular.AfterLoadDFMValues;
    edtitular.AfterLoadDFMValues;
    lbabertura.AfterLoadDFMValues;
    edabertura.AfterLoadDFMValues;
    lbagencia_nome.AfterLoadDFMValues;
    edagencia_nome.AfterLoadDFMValues;
    lbagencia_numero.AfterLoadDFMValues;
    edagencia_numero.AfterLoadDFMValues;
    lbagencia_dv.AfterLoadDFMValues;
    edagencia_dv.AfterLoadDFMValues;
    lbconta_numero.AfterLoadDFMValues;
    edconta_numero.AfterLoadDFMValues;
    lbconta_dv.AfterLoadDFMValues;
    edconta_dv.AfterLoadDFMValues;
    lbdv_agencia_conta.AfterLoadDFMValues;
    eddv_agencia_conta.AfterLoadDFMValues;
    lbcodigo_mestre.AfterLoadDFMValues;
    edcodigo_mestre.AfterLoadDFMValues;
    lbsaldo_abertura.AfterLoadDFMValues;
    edsaldo_abertura.AfterLoadDFMValues;
    lbsaldo.AfterLoadDFMValues;
    edsaldo.AfterLoadDFMValues;
    lbobs.AfterLoadDFMValues;
    edobs.AfterLoadDFMValues;
    lbcpf_cnpj.AfterLoadDFMValues;
    edcpf_cnpj.AfterLoadDFMValues;
    lbconta_bancaria.AfterLoadDFMValues;
    edconta_bancaria.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ContasDataset.AfterLoadDFMValues;
    ContasDatasetid.AfterLoadDFMValues;
    ContasDatasetaliado_id.AfterLoadDFMValues;
    ContasDatasetdata_base_id.AfterLoadDFMValues;
    ContasDatasetbanco_id.AfterLoadDFMValues;
    ContasDatasetnome.AfterLoadDFMValues;
    ContasDatasettitular.AfterLoadDFMValues;
    ContasDatasetabertura.AfterLoadDFMValues;
    ContasDatasetagencia_nome.AfterLoadDFMValues;
    ContasDatasetagencia_numero.AfterLoadDFMValues;
    ContasDatasetagencia_dv.AfterLoadDFMValues;
    ContasDatasetconta_numero.AfterLoadDFMValues;
    ContasDatasetconta_dv.AfterLoadDFMValues;
    ContasDatasetdv_agencia_conta.AfterLoadDFMValues;
    ContasDatasetcodigo_mestre.AfterLoadDFMValues;
    ContasDatasetsaldo_abertura.AfterLoadDFMValues;
    ContasDatasetsaldo.AfterLoadDFMValues;
    ContasDatasetobs.AfterLoadDFMValues;
    ContasDatasetcpf_cnpj.AfterLoadDFMValues;
    ContasDatasetconta_bancaria.AfterLoadDFMValues;
    ContasDatasetcodigo_interno.AfterLoadDFMValues;
    ContasDatasetexcluido.AfterLoadDFMValues;
    ContasDatasetinclusao.AfterLoadDFMValues;
    ContasDatasetalteracao.AfterLoadDFMValues;
    ContasDatasetexclusao.AfterLoadDFMValues;
    XDataClientContasGet.AfterLoadDFMValues;
    XDataClientContasDelete.AfterLoadDFMValues;
  end;
end;

end.
